<template>
  <div id="coveFeaturedDisplay">
    <featured 
      v-show="!!featured.records" 
      :events="featured.records" />
  </div>
</template>

<script>
import Featured from "./components/featured.vue";
let sComponents = { Featured };

export default {
  name: "FeaturedGrid",
  components: sComponents,
  props: {},
  data: function() {
    return {
      featured: {'records': []},
    };
  },
  watch: {
    featured: function(val){
      const vm = this
      if(val.records.length > 4){
        let limitRecords = []
        val.records.map(function(r, i){
          if(i < 4){
            limitRecords.push(r)
          }
        })
        if(limitRecords.length > 0){
          vm.featured.records = limitRecords
        }
      }
    }
  }
};
</script>